export default __webpack_public_path__ + "static/media/RotatoryTillerandSeedDrill.789e1386.jpg";